import { useLocation } from 'react-router-dom';
import { page } from '@content';

import { AdminTab } from './Admin.types';

export const useGetPathForTabs = (adminTabs: AdminTab[]) => {
  const { pathname } = useLocation();

  // get key of matching pathname to page value
  // const match = TABS.map((tab) => page[tab.path] == pathname);
  const match = adminTabs.find((tab) => page[tab.path] === pathname);

  // if match, return pathname
  if (match) {
    return pathname;
  }

  // otherwise, get path of first tab
  // this is a fallback in case the pathname does not match any tab
  return page[adminTabs[0].path];
};
